import React from 'react';

import { formatNumber } from '../utils';

const DisplayCost = ({ totalCost = 0 }) => {
	const displayCost = totalCost || 0;

	return (
		<div className="d-flex align-items-center ">
			<p className="mr-1">${formatNumber(displayCost)}</p>
		</div>
	);
};
export default DisplayCost;
